import { RuntimeLoader } from "@rive-app/react-canvas";
import riveWasmUrl from "@rive-app/canvas/rive.wasm?url";

let bootstrapped = false;

export function bootstrapRive(): void {
  if (bootstrapped) return;
  bootstrapped = true;

  RuntimeLoader.setWasmUrl(riveWasmUrl);
  // Disable the jsdelivr fallback so we never silently phone home if the
  // bundled asset 404s — fail loudly instead.
  RuntimeLoader.setWasmFallbackUrl(null);
}
